var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EXTooltip,{attrs:{"title":"Drill down into version","placement":"top"}},[_c('div',{staticClass:"procedure-version-badge"},[_c('span',[_vm._v("v."+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }